import {type ComAtprotoServerDescribeServer} from '@atproto/api'
import type React from 'react'

import {LoginFormDesktop} from '#/screens/Login/LoginFormDesktop.web.tsx'
import {LoginFormMobile} from '#/screens/Login/LoginFormMobile.web.tsx'
import {useIsMobileWeb} from '#/alf'

type ServiceDescription = ComAtprotoServerDescribeServer.OutputSchema

export const LoginForm = ({
  error,
  serviceUrl,
  serviceDescription,
  initialHandle,
  setError,
  setServiceUrl,
  onPressRetryConnect,
  onPressBack,
  onPressForgotPassword,
  onAttemptSuccess,
  onAttemptFailed,
}: {
  error: string
  serviceUrl: string
  serviceDescription: ServiceDescription | undefined
  initialHandle: string
  setError: (v: string) => void
  setServiceUrl: (v: string) => void
  onPressRetryConnect: () => void
  onPressBack: () => void
  onPressForgotPassword: () => void
  onAttemptSuccess: () => void
  onAttemptFailed: () => void
}) => {
  const isMobileWeb = useIsMobileWeb()
  if (isMobileWeb) {
    return (
      <LoginFormMobile
        error={error}
        serviceUrl={serviceUrl}
        serviceDescription={serviceDescription}
        initialHandle={initialHandle}
        setError={setError}
        setServiceUrl={setServiceUrl}
        onPressRetryConnect={onPressRetryConnect}
        onPressBack={onPressBack}
        onPressForgotPassword={onPressForgotPassword}
        onAttemptSuccess={onAttemptSuccess}
        onAttemptFailed={onAttemptFailed}
      />
    )
  }
  return (
    <LoginFormDesktop
      error={error}
      serviceUrl={serviceUrl}
      serviceDescription={serviceDescription}
      initialHandle={initialHandle}
      setError={setError}
      setServiceUrl={setServiceUrl}
      onPressRetryConnect={onPressRetryConnect}
      onPressBack={onPressBack}
      onPressForgotPassword={onPressForgotPassword}
      onAttemptSuccess={onAttemptSuccess}
      onAttemptFailed={onAttemptFailed}
    />
  )
}
